import { useI18n } from 'vue-i18n';
import moment from 'moment';
import { useLocale as useVuetifyLocale } from 'vuetify';
import { useAppStore } from '@/store/app';

export function useLocale() {
    const i18n = useI18n();
    const { current: vuetifyCurrent } = useVuetifyLocale();

    const setLocale = (locale: string) => {
        if (locale.includes('pt')) locale = 'pt';
        else locale = 'en';
        useAppStore().setLocale(locale);
        i18n.locale.value = locale;
        moment.locale(locale);
        vuetifyCurrent.value = locale;
    };

    const getLocale = () => {
        return useAppStore().getLocale;
    };

    return {
        setLocale,
        getLocale,
    };
}
